import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PatientInfo from './apollo/PatientInfo';
import Admin from './Admin';
import CodingHome from './coding/CodingHome';
import CodingFlowHome from './coding_flow/CodingFlowHome';

function App() {
  const [currentView, setCurrentView] = useState('');
  const [username, setUsername] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userParam = urlParams.get('user');
    const tokenParam = urlParams.get('token');
    const pathName = window.location.pathname;

    if (pathName === '/admin') {
      setCurrentView('admin');
      if (userParam && tokenParam) {
        setUsername(userParam);
        setToken(tokenParam);
      }
      return;
    }

    // ...existing code...
  }, []);

  const renderCurrentView = () => {
    if (currentView === 'admin') {
      return <Admin username={username} token={token} />;
    }
    // ...existing view logic...
  };

  return (
    <Router>
      <Routes>
        <Route path="/apollo/:pid/:user" element={<PatientInfo />} />
        <Route path="/patient_info/:pid/:user" element={<PatientInfo />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/coding/:patient_id?" element={<CodingHome />} />
        <Route path="/coding_flow/:page?" element={<CodingFlowHome />} />
      </Routes>
    </Router>
  );
}

export default App;
